import { QueryClient } from '@tanstack/react-query';
import { LIST_ITEMS_COUNT } from '@/constants/lists.constants';
import { hospitalQueries } from '@/queries/hospital/hospital.query';
import { hospitalContactsQueries } from '@/queries/hospital-contacts';

export const hospitalsLoader = (queryClient: QueryClient) => () => {
  return queryClient.ensureQueryData(hospitalQueries.list({ itemsPerPage: LIST_ITEMS_COUNT, pageIndex: 0 }));
};

export const hospitalByIdLoader = (queryClient: QueryClient) => (hospitalId: string) => {
  return queryClient.fetchQuery({
    ...hospitalQueries.item(hospitalId),
  });
};

export const hospitalContactByIdLoader = (queryClient: QueryClient) => (contactId: string) => {
  return queryClient.ensureQueryData({
    ...hospitalContactsQueries.item(contactId),
    revalidateIfStale: true,
  });
};
